export const USER_ROLE = 'user';
export const CHATBOT_ROLE = 'assistant';
export const WELCOME_MESSAGE_KEYWORD = '\\welcome_message';

export enum ChatbotState {
  DISABLED = 'disabled',
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
}
